import { configureStore, createSlice } from '@reduxjs/toolkit';

const buyerLandingPageSlice = createSlice({
  name: 'buyerLandingPage',
  initialState: {},
});

export const store = configureStore({
  reducer: buyerLandingPageSlice.reducer,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
